export const NOTIFY_TEXT_MAX_LENGTH = 50;

export enum ReactionsNotificationLevel {
    NONE = 'none',
    DIRECT = 'direct',
    CONVERSATIONS = 'conversation',
}
